export default [
	{
		modulo: 35,
		privilegio: 362,
		routerName: 'voos-escala',
		routerPath: '/voos-escala',
		componentName: 'VoosEscala',
		componentPath: 'modules/layout/gestao-escala-tripulante/voos/main'
	},
	{
		modulo: 35,
		privilegio: 362,
		routerName: 'voo-escala-cadastrar',
		routerPath: '/voo-escala-cadastrar',
		componentName: 'VoosEscalaCadastrar',
		componentPath: 'modules/layout/gestao-escala-tripulante/voos/cadastro'
	},
	{
		modulo: 35,
		privilegio: 391,
		routerName: 'listar-lei-aeronauta',
		routerPath: '/listar-lei-aeronauta',
		componentName: 'ListarLeiAeronauta',
		componentPath:
			'modules/layout/gestao-escala-tripulante/lei-aeronauta/listar/listar-lei'
	},
	{
		modulo: 35,
		privilegio: 391,
		routerName: 'cadastrar-parametro-lei-aeronauta',
		routerPath: '/cadastrar-parametro',
		componentName: 'CadastrarLeiAeronauta',
		componentPath:
			'modules/layout/gestao-escala-tripulante/lei-aeronauta/cadastrar/cadastrar'
	},
	{
		modulo: 35,
		privilegio: 391,
		props: true,
		routerName: 'editar-parametro-lei-aeronauta',
		routerPath: '/editar-parametro/:id',
		componentName: 'CadastrarLeiAeronauta',
		componentPath:
			'modules/layout/gestao-escala-tripulante/lei-aeronauta/cadastrar/cadastrar'
	},
	{
		modulo: 35,
		privilegio: 362,
		routerName: 'listar-mes-escala',
		routerPath: '/listar-mes-escala',
		componentName: 'listarEscalas',
		componentPath:
			'modules/layout/gestao-escala-tripulante/escala/listar-escalas'
	},
	{
		modulo: 35,
		privilegio: 362,
		props: true,
		routerName: 'escala',
		routerPath: '/escala/:idEscala',
		componentName: 'EscalaTripulante',
		componentPath:
			'modules/layout/gestao-escala-tripulante/escala/escala/escala'
	},
	{
		privilegio: 362,
		routerName: 'grupo-voos-escala',
		routerPath: '/grupo-voos',
		componentName: 'GrupoVoos',
		componentPath: 'modules/layout/gestao-escala-tripulante/grupo-voo/main'
	},
	{
		modulo: 35,
		privilegio: 377,
		routerName: 'listar-mes-escala-visualizacao',
		routerPath: '/listar-mes-escala-visualizacao',
		componentName: 'EscalaTripulanteVisualizacao',
		componentPath:
			'modules/layout/gestao-escala-tripulante/escala-visualizacao-tripulante/listar-escala-tripulante'
	},
	{
		modulo: 35,
		privilegio: 377,
		props: true,
		routerName: 'escala-visualizacao',
		routerPath: '/escala/:mesAno/:idTripulante',
		componentName: 'EscalaTripulanteVisualizacao',
		componentPath:
			'modules/layout/gestao-escala-tripulante/escala-visualizacao-tripulante/escala-visualizacao/escala-visualizacao'
	},
	{
		modulo: 35,
		privilegio: 377,
		routerName: 'listar-solicitacao-folga',
		routerPath: '/listar-solicitacao-folga',
		componentName: 'Solicitacao-folga',
		componentPath:
			'modules/layout/gestao-escala-tripulante/solicitacao-folga/listar/listar-solicitacao-folga'
	},
	{
		modulo: 35,
		privilegio: 377,
		routerName: 'cadastrar-solicitacao-folga',
		routerPath: '/cadastrar-solicitacao-folga',
		componentName: 'CadastrarSolicitacaoFolga',
		componentPath:
			'modules/layout/gestao-escala-tripulante/solicitacao-folga/cadastrar/cadastrar'
	},
	{
		modulo: 35,
		privilegio: 377,
		props: true,
		routerName: 'editar-solicitacao-folga',
		routerPath: '/editar-solicitacao-folga/:id',
		componentName: 'CadastrarSolicitacaoFolga',
		componentPath:
			'modules/layout/gestao-escala-tripulante/solicitacao-folga/cadastrar/cadastrar'
	},
	{
		modulo: 35,
		privilegio: 400,
		routerName: 'situacao-tripulantes',
		routerPath: '/situacao-tripulantes',
		componentName: 'SituacaoTripulacao',
		componentPath:
		'modules/layout/gestao-escala-tripulante/situacao-tripulacao/selecao-situacao-tripulacao'
	},
	{
		privilegio: 401,
		routerName: 'gerencimaneto-risco-fadiga',
		routerPath: '/gerencimaneto-risco-fadiga',
		componentName: 'GerenciamentoRiscoFadiga',
		componentPath:
			'modules/layout/gestao-escala-tripulante/gerenciamento-risco-fadiga/main'
	},
	{
		modulo: 35,
		privilegio: 405,
		routerName: 'cadastro-controle-diarias-alimentacao',
		routerPath: '/valores-diarias-alimentacao',
		componentName: 'ValoresDiariasAlimentacao',
		componentPath:
			'modules/layout/gestao-escala-tripulante/cadastro-controle-diarias-alimentacao/main'
	},	
	{
		modulo: 35,
		privilegio: 405,
		routerName: 'controle-diarias-alimentacao',
		routerPath: '/controle-diarias-alimentacao',
		componentName: 'ControleDiariasAlimentacao',
		componentPath:
			'modules/layout/gestao-escala-tripulante/controle-diarias-alimentacao/main'
	},
]
